/* P07: open the product gallery on the selected variant image without any
   start-up animation. Animations return on the first user interaction. */
(function () {
  var F = window.Flickity, $ = window.jQuery;
  var interacted = false;
  function mark() { interacted = true; if ($ && $.fx) { $.fx.off = false; } }
  ['pointerdown', 'touchstart', 'keydown', 'wheel'].forEach(function (t) {
    window.addEventListener(t, mark, { capture: true, passive: true, once: true });
  });
  if ($ && $.fx) {
    $.fx.off = true;
    window.addEventListener('load', function () {
      setTimeout(function () { $.fx.off = false; }, 0);
    });
  }
  if (!F || !F.prototype || typeof F.prototype.select !== 'function') { return; }
  var select = F.prototype.select;
  F.prototype.select = function (index, isWrap, isInstant) {
    if (!interacted && this.element && this.element.classList.contains('primgSlider')) {
      isInstant = true;
    }
    return select.call(this, index, isWrap, isInstant);
  };
})();
